<template>
    <div class="appointment">
      <van-nav-bar title="按摩放松预约" fixed />
      <van-field
        readonly
        clickable
        label="设备"
        :value="deviceName"
        placeholder="选择设备"
        @click="showPicker = true"
      />
      <van-popup v-model="showPicker" round position="bottom">
        <van-picker
          show-toolbar
          :loading="pickerLoading"
          :columns="columns"
          @cancel="showPicker = false"
          @confirm="onConfirm"
        />
      </van-popup>
      <van-divider>可预约时段</van-divider>
      <van-empty v-show="selectedDid === ''" description="请先选择按摩设备" />
      <van-empty v-show="selectedDid!== '' && timeSlots.length === 0" description="暂无可预约时段" />
      <van-cell v-for="item in timeSlots" :key="item.date" :title="item.date" :value="item.slots.length +'个时段'" is-link to="/apt" @click="setCurrntSlotList(item.date, item.slots, selectedDid, deviceName)" />
    </div>
</template>

<script>
import { getTimeSlotsByDid } from '@/api/apt'
import { getAllDevices } from '@/api/home'

export default {
  name: 'AppointmentIndex',
  data () {
    return {
      deviceList: [],
      // 选择器
      deviceName: '',
      pickerLoading: true,
      showPicker: false,
      columns: [],
      selectedDid: '',
      // 预约时段列表
      timeSlots: []
    }
  },
  methods: {
    async getTimeSlots (selectedDid) {
      // 获取预约时段列表
      const res = await getTimeSlotsByDid(selectedDid)
      this.timeSlots = res.data.dates
      this.selectedDid = selectedDid
    },
    onConfirm (value, index) {
      // 获取选中的设备对象
      const selectedDevice = this.deviceList[index]
      // 设置设备名称和ID
      this.deviceName = value
      this.showPicker = false
      // 获取预约时段列表
      this.getTimeSlots(selectedDevice.did)
    },
    // 获取设备列表
    async getDevicesList () {
      this.pickerLoading = true
      const res = await getAllDevices()
      this.deviceList = res.data
      this.columns = res.data.map(item => item.name)
      this.pickerLoading = false
    },
    setCurrntSlotList (date, slots, selectedDid, deviceName) {
      this.$store.commit('apt/setCurrentSlots', { date, slots, deviceId: selectedDid, deviceName })
    }
  },
  async created () {
    await this.getDevicesList()
  }
}
</script>

<style lang="less" scoped>
.appointment {
  padding-top: 46px;
}
</style>
